// Stub module: the admin app exposes a full aiEngine GraphQL surface; the
// webapp_contextstory project does not. Ported components (PreviewFile) call
// `apiGetAllAIEngines` only to populate the AI-summary agent picker, so the
// stub returns an empty list. UI gracefully shows "no agents available".
export const apiGetAllAIEngines = async () => {
  return { aiEngines: [] };
};

export default { apiGetAllAIEngines };
